import { intl } from '@fullstory/intl';
import classNames from 'classnames';
import React from 'react';
import styles from './LoadingShimmer.module.scss';

interface LoadingShimmerProps {
  /** Number of lines to show in the shimmer effect */
  lines?: number;
  /** Optional className to apply to the container */
  className?: string;
}

export const LoadingShimmer: React.FC<LoadingShimmerProps> = ({ lines = 3, className }) => (
  <div className={classNames(styles.shimmerContainer, className)}>
    {Array.from({ length: lines }).map((_, index) => (
      <div
        key={index}
        className={styles.shimmerLine}
        role="progressbar"
        aria-label={intl.formatMessage({ defaultMessage: 'Loading content', id: '3Pyhwf' })}
      />
    ))}
  </div>
);
